import { Link } from "react-router-dom";

const Sidebar = () => {
  return (
    <div className="main-sidebar" id="main-sidebar">
      <ul className="sidebar-menu" id="simple-bar">
        <li className="sidebar-list">
          <Link to="/companies" className="sidebar-link">
            <h6 className="lan-2">Cég lista</h6>
          </Link>
        </li>
        <li className="sidebar-list">
          <Link to="/" className="sidebar-link">
            <h6 className="lan-2">Felhasználó lista</h6>
          </Link>
        </li>
        <li className="sidebar-list">
          <Link to="/notifications" className="sidebar-link">
            <h6 className="lan-3">Értesítés lista</h6>
          </Link>
        </li>
        <li className="sidebar-list">
          <Link to="/notification-types" className="sidebar-link">
            <h6 className="lan-3">Értesítés típusok</h6>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
